export const PLAYGROUND_AUTH_REQUEST = "anima:playground-auth-request";
export const PLAYGROUND_AUTH_RESPONSE = "anima:playground-auth-response";

const PROJECTS_ORIGIN_PATTERN =
  /^https:\/\/(?:[a-z0-9-]+-)?projects\.animaapp\.com$/;

export function isAllowedProjectsOrigin(origin: string): boolean {
  if (PROJECTS_ORIGIN_PATTERN.test(origin)) return true;

  if (!import.meta.env.PROD) {
    return /^http:\/\/localhost:\d+$/.test(origin);
  }

  return false;
}

export function getSessionIdFromPath(pathname: string): string | null {
  const sessionId = pathname.split("/").filter(Boolean)[0];
  return sessionId || null;
}
